import React, { useState, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";

import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Transition } from "@headlessui/react";
export  function AdHome() {
  const [selectedEditIndex, setSelectedEditIndex] = useState(-1);
  const [showAddAddressForm, setShowAddAddressForm] = useState(false);

  



  const handleAdd = (address) => {
    /* if (userInfo.addresses && userInfo.addresses) {
      const newUser = { ...userInfo, addresses: [...userInfo.addresses, address] };
      dispatch(updateUserAsync(newUser));
      setShowAddAddressForm(false);
      reset(); // Reset the form fields
    }*/
  };
  return (
    <div>
      <div className="relative isolate px-6 pt-14 lg:px-8">
        <div
          className="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80"
          aria-hidden="true"
        >
          <div
            className="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[30.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]"
            style={{
              clipPath:
                "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
            }}
          />
        </div>
        <div className="mx-auto max-w-2xl py-16 sm:py-16 lg:py-16">
          <div className="  sm:mb-8 flex justify-center">
            Welcome to{" "}
            <span className="text-xl font-serif font-bold ">
              Kc Fitness Studio
            </span>
            <span class="hidden sm:relative sm:flex sm:h-3 sm:w-3">
              {/*animate-ping*/}
              <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-sky-400 opacity-75">
                <span className="text-xl font-serif font-bold ">
                  Kc Fitness Studio
                </span>{" "}
              </span>
              <span class="relative inline-flex rounded-full h-3 w-3 bg-sky-500"></span>
            </span>
          </div>
          <div className="text-center">
            <h1 className="text-4xl font-bold tracking-tight textM sm:text-6xl">
              Ready to Start Your Journey Now With Us
            </h1>
            <p className="mt-6 text-lg leading-8 text-gray-600">
              At <span className="font-bold">Kc Fitness Studio</span>, we are
              more than just a fitness center; we're a community dedicated to
              helping you achieve your health and wellness goals. Our
              state-of-the-art facility, expert trainers, and wide range of
              fitness programs make us the ultimate destination for fitness
              enthusiasts of all levels.
            </p>

            <div className="mt-10 flex items-center justify-center gap-x-6">
              {!showAddAddressForm && (
                <button
                  onClick={() => setShowAddAddressForm(true)}
                  type="button"
                  className="rounded-md my-5 bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                >
                  Read Rules
                </button>
              )}

              <Transition
                show={showAddAddressForm}
                as={Fragment}
                enter="transition-opacity duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="transition-opacity duration-300"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <form
                  className="bg-white rounded-lg px-6 py-16 mt-12 drop-shadow-2xl"
                  noValidate
                 
                >
                  <div className="space-y-12">
                    <div className="border-b border-gray-900/10 pb-12">
                      <h2 className="text-2xl font-semibold leading-7 text-gray-900">
                        Follow  GYM Rules
                      </h2>
                      <p className="mt-1 text-md leading-6 text-gray-600">
                        You Follow  Rules Your Body Grow up Faster
                      </p>
                      <p className="mt-1 text-xl leading-6 text-gray-600">
                      1. Respect others: Be mindful of personal space and don't disrupt someone else's workout.
                      </p>
                      <p className="mt-1 text-xl leading-6 text-gray-600">
                      2. Cleanliness: Wipe down equipment after use and put away weights and equipment when you're done.


                      </p>
                      <p className="mt-1 text-xl leading-6 text-gray-600">
                      3. Proper attire: Wear appropriate workout attire and indoor shoes.

                      </p>
                      <p className="mt-1 text-xl leading-6 text-gray-600">
                      4. Noise level: Keep noise to a minimum, including loud music and grunting.

                      </p>
                      <p className="mt-1 text-xl leading-6 text-gray-600">
                      5. Sharing equipment: Allow others to work in between sets if the gym is busy.
                      </p>
                      <p className="mt-1 text-xl leading-6 text-gray-600">
                      6. Safety: Use proper form and technique to avoid injury, and ask for assistance if needed.
                      </p>
                      <p className="mt-1 text-xl leading-6 text-gray-600">
                      7. Cell phones: Keep phone usage to a minimum and avoid talking loudly on the phone.
                      </p>
                      <p className="mt-1 text-xl leading-6 text-gray-600">
                      8. Time limits: Be mindful of time limits on equipment during busy hours.
                      </p>
                      <p className="mt-1 text-xl leading-6 text-gray-600">
                      9. Hygiene: Use deodorant, bring a towel, and shower before using the gym.
                      </p>
                      <p className="mt-1 text-xl leading-6 text-gray-600">
                      10. Follow posted rules: Pay attention to any specific rules or policies posted by the gym.

                      </p>
                      <p className="mt-1 text-md leading-6 text-gray-600">
                      Remember, gym rules may vary from place to place, so it's always a good idea to check with your specific gym for their rules and guidelines.
                      </p>
                     
                    </div>

                    <div className="mt-6 flex items-center justify-end gap-x-6">
                      <button
                        onClick={() => {
                          setShowAddAddressForm(false); // Set the state to close the form
                       
                        }}
                        type="button"
                        className="rounded-md my-5 bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
                      >
                        Okys!
                      </button>
                     
                    </div>
                  </div>
                </form>
              </Transition>
              {!showAddAddressForm && (
                <Link
                  to="/gallery"
                  className="text-sm font-semibold leading-6 text-gray-900"
                >
                  Gym Gallery <span aria-hidden="true">→</span>
                </Link>
              )}
            </div>
          </div>
        </div>
        <div
          className="absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]"
          aria-hidden="true"
        >
          <div
            className="relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]"
            style={{
              clipPath:
                "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
            }}
          />
        </div>
      </div>
    </div>
  );
}
